// libs.
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { monserratSemiBold } from '@habitech/shared';

// components.
import { Layout } from '@shared';
import { DocumentsTitle } from './components/DocumentsTitle';
import { getNidSelected } from '@domains/documents-review/store/slices/document-review-slice';
import { SidebarDocuments } from '../DocumentsAuditDashboard/components/SideBarDocuments/SideBarDocuments';
import { DocumentsModalViewer } from '../DocumentTaskDetail/components/DocumentsViewer/DocumentsViewer';
import { DocumentsHistorySection } from '@domains/orchestrator-pricing-committee/components/OrchestratorStep/components/StepTrackerLine/components/DocumentsHistorySection';
import { InProgressStepsCards } from '@domains/orchestrator-pricing-committee/components/InProgressStepsCards/InProgressStepsCards';

export const DocumentsVisualizer = () => {
  const nid = useSelector(getNidSelected);

  return (
    <Layout>
      <SidebarDocuments />
      <div className="h-100 w-100">
        <DocumentsTitle />
        <Row
          className="m-0"
          style={{ height: 'calc(100% - 96px)', width: '100%' }}
        >
          {!nid && (
            <div
              className="d-flex justify-content-center h-100 align-items-center"
              style={{
                fontSize: '16px',
                fontFamily: monserratSemiBold,
                margin: 'auto',
              }}
            >
              No hay información disponible
            </div>
          )}
          {nid && (
            <>
              <Col className="p-4 h-100">
                <div
                  style={{ fontSize: '16px', fontFamily: monserratSemiBold }}
                  className="pb-4"
                >
                  Documentos NID: {nid}
                </div>
                <DocumentsModalViewer nid={nid} />
              </Col>
              <Col
                lg={6}
                className="p-4"
                style={{ overflowY: 'scroll', height: '100%' }}
              >
                <div
                  className="fw-bold px-4 pb-2 fs-6"
                  style={{ fontFamily: monserratSemiBold }}
                >
                  Historial Reintentos
                </div>
                <InProgressStepsCards nid={nid} />
                <DocumentsHistorySection nid={nid} />
              </Col>
            </>
          )}
        </Row>
      </div>
    </Layout>
  );
};
